import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TuiLet } from '@taiga-ui/cdk';
import { TuiTextfieldControllerModule, TuiMultiSelectModule, TuiSelectModule } from '@taiga-ui/legacy';
import { TuiButton, TuiDataList } from '@taiga-ui/core';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from '@src/app/components';
import { FieldModule } from '@src/app/shared/field';
import { IconModule } from '@src/app/modules/icon';

import {
  SearchCitiesInputComponent,
  RenderCityRowComponent,
  SearchCitiesViewComponent,
  SearchCitiesButtonComponent,
} from './components';
import { CitySwitcherComponent } from './city-switcher';

@NgModule({
  declarations: [
    SearchCitiesInputComponent,
    CitySwitcherComponent,
    RenderCityRowComponent,
    SearchCitiesViewComponent,
    SearchCitiesButtonComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ComponentsModule,
    TuiLet,
    TuiSelectModule,
    TuiTextfieldControllerModule,
    ...TuiDataList,
    TuiMultiSelectModule,
    TranslateModule,
    FieldModule,
    TuiButton,
    IconModule,
  ],
  exports: [SearchCitiesInputComponent, CitySwitcherComponent, SearchCitiesViewComponent, SearchCitiesButtonComponent],
})
export class SearchCitiesModule {}
